import { Controller } from 'stimulus';
import Swiper, { Pagination, EffectFade } from 'swiper';

class ThreeColCarousel extends Controller {

  connect() {
    Swiper.use([Pagination, EffectFade]);
    this.swiper = new Swiper('.swiper-three-col', {
      autoplay: {
        delay: 5000,
      },
      loop: true,
      spaceBetween: 32,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-three-col-pagination',
        renderBullet: (index, className) => {
          return `<span class="${className}"></span>`;
        },
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 32,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },

        1024: {
          spaceBetween: 24,
          slidesPerView: 3,
          slidesPerGroup: 3,
        },

        1280: {
          spaceBetween: 32,
          slidesPerView: 3,
          slidesPerGroup: 3,
        }
      },
    });
  }
}

export default ThreeColCarousel;